import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetBoxWide, {
  Props as WidgetBoxProps,
} from '@wix/da-gruser-shared/pkg/components/WidgetBoxWide';
import AboutMe from '../AboutMe';

interface Props {
  moduleId: number;
  widgetBoxProps?: Partial<WidgetBoxProps>;
}

const AboutMeBoxWide: React.FC<Props> = ({ moduleId, widgetBoxProps }) => {
  const { t } = useTranslation();
  return (
    <WidgetBoxWide
      moduleId={moduleId}
      header={t('widgets.aboutMe.header')}
      {...widgetBoxProps}
    >
      <AboutMe moduleId={moduleId} />
    </WidgetBoxWide>
  );
};
AboutMeBoxWide.displayName = 'AboutMeBoxWide';

export default AboutMeBoxWide;
